module.exports = __webpack_public_path__ + "static/img/1.c5ea1f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/sp/1.png
// module id = 9xTU
// module chunks = 0